import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelRadio as _vModelRadio, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-436d2445"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ProductList" }
const _hoisted_2 = { class: "areaWarpper" }
const _hoisted_3 = ["id", "value"]
const _hoisted_4 = ["for"]
const _hoisted_5 = { class: "titleWarpper" }
const _hoisted_6 = { class: "title" }
const _hoisted_7 = { class: "tips" }
const _hoisted_8 = { class: "area" }
const _hoisted_9 = { class: "bottomAction" }
const _hoisted_10 = { class: "time" }
const _hoisted_11 = /*#__PURE__*/_createTextVNode("查看详情")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_tab = _resolveComponent("van-tab")!
  const _component_van_tabs = _resolveComponent("van-tabs")!
  const _component_VanButton = _resolveComponent("VanButton")!
  const _component_VanList = _resolveComponent("VanList")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.areaList, (item, idx) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "areaItem",
          key: `radio${idx}`
        }, [
          _withDirectives(_createElementVNode("input", {
            type: "radio",
            id: `radio${idx}`,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.getListData.areaId) = $event)),
            value: item[0],
            name: "area",
            onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.fliter && _ctx.fliter(...args)))
          }, null, 40, _hoisted_3), [
            [_vModelRadio, _ctx.getListData.areaId]
          ]),
          _createElementVNode("label", {
            class: "label",
            for: `radio${idx}`
          }, _toDisplayString(item[1]), 9, _hoisted_4)
        ]))
      }), 128))
    ]),
    _createVNode(_component_van_tabs, {
      color: "#19be6b",
      onChange: _ctx.tabChange
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.categoryTitle, (item, idx) => {
          return (_openBlock(), _createBlock(_component_van_tab, {
            title: item[1],
            name: item[0],
            key: `tabItem${idx}`
          }, null, 8, ["title", "name"]))
        }), 128))
      ]),
      _: 1
    }, 8, ["onChange"]),
    _createVNode(_component_VanList, {
      class: "list",
      listLoading: _ctx.listLoading,
      "onUpdate:listLoading": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.listLoading) = $event)),
      onLoad: _ctx.getList,
      "immediate-check": false,
      finished: _ctx.finished,
      "finished-text": "没有更多了"
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.list, (item, idx) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "listItem",
            key: `item${idx}`
          }, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, _toDisplayString(item.categoryName), 1)
            ]),
            _createElementVNode("div", _hoisted_7, _toDisplayString(item.profile), 1),
            _createElementVNode("div", _hoisted_8, "用苗地区：" + _toDisplayString(item.receiptAddress), 1),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.timeToNow(Number(item.createTime))), 1),
              _createVNode(_component_VanButton, {
                size: "mini",
                color: "#FFCC32",
                onClick: ($event: any) => (_ctx.$router.push({name:"BuyDetail",query:{id:item.id}}))
              }, {
                default: _withCtx(() => [
                  _hoisted_11
                ]),
                _: 2
              }, 1032, ["onClick"])
            ])
          ]))
        }), 128))
      ]),
      _: 1
    }, 8, ["listLoading", "onLoad", "finished"])
  ]))
}